import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const Label = styled(Box).attrs({
  color: 'secondaryText',
  pb: 2,
})`
  opacity: ${p => (p.isDisabled ? 0.4 : 1)};
`;

export const ButtonContainer = styled(Box).attrs(() => ({}))``;

export const ErrorWrapper = styled(Box).attrs(() => ({
  width: '100%',
  horizontal: true,
}))``;

export const Link = styled.a`
  text-decoration: none;
  color: inherit;
`;
